export const loadAMap = ()=>{
    return new Promise((resolve, reject) => {
      console.log('加载高德地图')
      if(window.AMap) {resolve()};
      window.init = ()=>{
        resolve()
      };
      const script = document.createElement('script')
      script.type = 'text/javascript'
      script.src = '//webapi.amap.com/maps?v=2.0&key=5f188a27d0f2b26ed95b5d4651034954&plugin=AMap.Geocoder,AMap.Driving&callback=init'
      script.onerror = reject
      document.head.appendChild(script)
    })
}
